import { useRcPortalWindowContext } from '../../../../foundation';
import { LogLevel } from '../loggerSystem';
import useSize from './useSize';
export default function useChangedListContentsSizes(callback, itemSize, enabled, scrollContainerStateCallback, log, customScrollParent) {
    var _a = useRcPortalWindowContext().externalWindow, externalWindow = _a === void 0 ? window : _a;
    return useSize(function (el) {
        var ranges = getChangedChildSizes(el.children, itemSize, 'offsetHeight', log);
        var scrollableElement = el.parentElement;
        while (!scrollableElement.dataset['virtuosoScroller']) {
            scrollableElement = scrollableElement.parentElement;
        }
        var scrollTop = customScrollParent
            ? customScrollParent.scrollTop
            : // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                scrollableElement.firstElementChild.dataset['viewportType'] === 'window'
                    ? externalWindow.pageYOffset ||
                        externalWindow.document.documentElement.scrollTop
                    : scrollableElement.scrollTop;
        scrollContainerStateCallback({
            scrollTop: Math.max(scrollTop, 0),
            scrollHeight: (customScrollParent !== null && customScrollParent !== void 0 ? customScrollParent : scrollableElement).scrollHeight,
            viewportHeight: (customScrollParent !== null && customScrollParent !== void 0 ? customScrollParent : scrollableElement).offsetHeight,
        });
        if (ranges !== null) {
            callback(ranges);
        }
    }, enabled);
}
function getChangedChildSizes(children, itemSize, field, log) {
    var length = children.length;
    if (length === 0) {
        return null;
    }
    var results = [];
    for (var i = 0; i < length; i++) {
        var child = children.item(i);
        if (!child || child.dataset.index === undefined) {
            continue;
        }
        // eslint-disable-next-line radix
        var index = parseInt(child.dataset.index);
        var knownSize = parseFloat(child.dataset.knownSize);
        var size = itemSize(child, field);
        if (size === 0) {
            log('Zero-sized element, this should not happen', { child: child }, LogLevel.ERROR);
        }
        if (size === knownSize) {
            continue;
        }
        var lastResult = results[results.length - 1];
        if (results.length === 0 ||
            lastResult.size !== size ||
            lastResult.endIndex !== index - 1) {
            results.push({ startIndex: index, endIndex: index, size: size });
        }
        else {
            results[results.length - 1].endIndex++;
        }
    }
    return results;
}
